import React from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';

const DlUnitSingleNav = ({ item }) => {
    // console.log('item');
    // console.log(item);
    
  return item.id != '' ? <div style={{ display: 'inline' }}>
        <Link to={{ pathname: '/admin-dashboard/dl-unit-edit/' + item.id, state: { ind: 0, item } }} >
            <span style={{marginLeft: '0%'}}>polja</span>
        </Link>         
        <Link to={{ pathname: '/admin-dashboard/dl-unit-edit-pdf/' + item.id }} style={{ display: item.uType == 'HM2' ? 'inline' : 'none' }} >
            <span style={{marginLeft: '2%'}}>pdf</span>
        </Link>         
        <Link to={{ pathname: '/admin-dashboard/dl-unit-edit-scan/' + item.id }} style={{ display: item.uType != 'HM2' ? 'inline' : 'none' }} >
            <span style={{marginLeft: '2%'}}>sken</span>
        </Link>         
    </div> : null;
}

export default DlUnitSingleNav;
